import React, { Component, useContext, useEffect, useRef, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
// import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime } from '../../Constants/Constants';
import Switch from "react-switch";

const LoadingCompnent = () => {
    return (
      <tr>
        <td colSpan={5} className="text-center py-3">
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span>Loading...</span>
          </div>
        </td>
      </tr>
    );
  };
  
 
  
const EmployeeAssignModule = () => {
    const { apiURL, apiHeaderFile, apiHeaderJson } = useContext(ConfigContext);
    const sourceDivRef = useRef(null); // Ref for the source div
    const [targetDivHeight, setTargetDivHeight] = useState("auto")
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [assignModuleModal, setAssignModuleModal] = useState(false);
    const [loadingPost, setLoadingPost] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [moduleData, setModuleData] = useState([]);
    const [originalModuleData, setOriginalModuleData] = useState([]);
    const [formData, setFormData] = useState({
        companyId: "",
        headerList:"",
        headerName: "",
        headerPath: "",
        headerStatus: "0",
        parentId: null,
    });
    const [errors, setErrors] = useState({});
    const [editableRow, setEditableRow] = useState(null);
    const [permissionRowData, setPermissionRowData] = useState(null);


    const getList = () => {
        const headers = apiHeaderJson;
        console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/GetEmployeeModuleList`, {
        // axios.get(`${apiURL}CompanyMasters/GetHeaderPermissionList`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.module_id, label: val?.header_name }
                });
                rows.unshift({ value: "All", label: "All" });
                setParentHeaderRows(rows);
                // setRows(data?.header_list);
            } else {
                setParentHeaderRows([]);
                // setRows([]);
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }
    const getAssignModuleList = () => {
        const headers = apiHeaderJson;
        console.log("headers =>",headers);
      
        axios.get(`${apiURL}CompanyMasters/GetEmployeeAssignedModules`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            const data = response.data;
            console.log(data);
            if (response.data.success === true) {
                const idList = data?.header_list?.map(item => item.module_id).join(",")
                setFormData({
                    ...formData,
                    headerList:idList,
                });
                setLoadingList(false);
            } else {
              // setParentHeaderRows([]);
               setFormData({
                ...formData,
                headerList: null,
            });
           
                setRows([]);
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            
            console.log("error", error);
        });
    }
    const getAssignList = () => {
        const headers = apiHeaderJson;
        console.log("headers =>",headers);
        setLoadingList(true);
        axios.get(`${apiURL}CompanyMasters/GetEmployeeModuleHierarchy`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                setModuleData(data?.result);
                setOriginalModuleData(data?.result);
                setRows(data?.result);
                // if (sourceDivRef.current) {
                //     const sourceHeight = sourceDivRef.current.offsetHeight;
                //     setTargetDivHeight(`${sourceHeight}px`);
                // }
                setLoadingList(false);
            } else {
               // setParentHeaderRows([]);
                setRows([]);
                setModuleData([]);
                setOriginalModuleData([]);
                setLoadingList(false);
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            setLoadingList(false);
            console.log("error", error);
        });
    }

    useEffect(() => {
        const sourceDiv = sourceDivRef.current;

        if (sourceDiv) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    // Update the target div height whenever the source div resizes
                    setTargetDivHeight(`${entry.contentRect.height}px`);
                }
            });

            // Observe the source div for resizing
            resizeObserver.observe(sourceDiv);

            return () => {
                // Clean up observer on component unmount
                resizeObserver.disconnect();
            };
        }
    }, []);

    const getCompanies = () => {
        const headers = apiHeaderJson;
        console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/getCompanies`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                let rows = data?.companies?.map((val,idx) => {
                    return  { value: val?.company_id, label: val?.company_name }
                });
                setCompanyOptions(rows);
                
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        if (isChanged) {
            getAssignList();
            getAssignModuleList();
            setIsChanged(false);
            setPermissionRowData(null);
            setEditableRow(null);  
        }
    }, [isChanged]);

    useEffect(() => {
        getList();
        getCompanies();
    }, []);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }
    const handleSlabMultiSelect = (fieldName, selectedOptions) => {
        // Generate the complete list of values from parentHeaderRows
        let allList = "";
        parentHeaderRows?.forEach((val) => {
            allList = allList + `${val?.value},`;
        });
        allList = allList.slice(0, -1); // Remove the trailing comma
    
        // Extract the selected values or set an empty array if no options are selected
        const selectedValues = selectedOptions?.map(option => option.value) || [];
    
        // Determine the value to assign: either allList or the selected IDs
        const valueToAssign = selectedValues.includes("All") ? allList : selectedValues.join(",");
        console.log("valueToAssign",valueToAssign);
    
        // Update the formData with the new value in headerList
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: valueToAssign, // Set the computed value for headerList
        }));
    };
     
    const getInfo = (id) => {
        const headers = apiHeaderJson;
        axios.get(`${apiURL}CompanyMasters/GetHeaderInfo`,
            {
                params: {
                    moduleId: id
                },
                headers
            }).then((response) => {
                const { success, result } = response.data;
                console.log(response?.data);
                if (success === true) {
                    setFormData({
                        ...formData,
                        module_id: result[0]?.module_id,
                        headerName: result[0]?.header_name,
                        headerPath: result[0]?.header_path,
                        headerStatus: result[0]?.header_status || "0",
                        parentId: result[0]?.parent_id,
                    });

                } else {

                }
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let check= formData?.headerList?.split(",")
        .filter(value => value.trim() !== "All") // Remove "All"
        .join(","); 
        setLoadingPost(true);
        let data = {
            headerList: check,
            date: currentDateAndTime(),
        }

        const headers = apiHeaderJson;
        axios
            .post(`${apiURL}CompanyMasters/AssignEmployeeModuleToCompany`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setFormData({
                        companyId: formData?.companyId,
                        headerList:"",
                        headerName: "",
                        headerPath: "",
                        headerStatus: "0",
                        parentId: "",
                    });
                    getAssignList();
                    setLoadingPost(false);
                    setAssignModuleModal(false)
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setLoadingPost(false);

                }
            });
    }

    const handleCheckboxChange = (value, module) => {
        console.log("value, module ==>", value, module);
    
        // Parse the permissions
        const updatedPermissions = JSON.parse(module.header_permissions);
        console.log("modules before ===>", moduleData);
    
        // Determine new permissions (add or remove)
        const newPermissions = updatedPermissions.includes(value)
            ? updatedPermissions.filter((item) => item !== value) // Remove if exists
            : [...updatedPermissions, value]; // Add if not exists
    
        // Create a new updated module object
        const updatedModule = {
            ...module,
            header_permissions: JSON.stringify(newPermissions), // Update the permissions
        };
        
        // Update the moduleData by finding the correct module and modifying it
        setModuleData((prevModuleData) => {
            const updatedModuleData = prevModuleData.map((mod) => {
                if (mod.header_id === updatedModule.header_id) {
                    return updatedModule; // Replace the module with the updated one
                }
                return mod; // Keep the other modules unchanged
            });
            return updatedModuleData;
        });
    
        setPermissionRowData(updatedModule);
    };
    
    const handleEdit = (rowName) => {
        setModuleData(originalModuleData);  
        setEditableRow(rowName);  
    };
    
    const handlePermission = () => {
         
        setLoadingPost(true);
        let data = {
            module_id: permissionRowData?.header_id,
            header_permissions: permissionRowData?.header_permissions,
            date: currentDateAndTime(),
        }

        console.log("handlePermission ~ data =======>>>", data);

        const headers = apiHeaderJson;
        
        axios
            .post(`${apiURL}CompanyMasters/HandleEmployeeModulePermission`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                console.log("handlePermission ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    
                    getAssignList();
                    setLoadingPost(false);
                    setPermissionRowData(null);
                    setEditableRow(null);  
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setLoadingPost(false);

                }
            });
    };

    const handleCancel = () => {
        setModuleData(originalModuleData);  
        setEditableRow(null);  
    };

    const handleToggleSwitch = (moduleId, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change header status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    moduleId: moduleId,
                    header_status: toggleButton ? "1" : "0",
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJson;
                // setToggleButton(!toggleButton);
                console.log(data);
                axios
                    .post(`${apiURL}CompanyMasters/HandleEmployeeModuleAccess`, data, {
                        params:{
                            user_id: localStorage.getItem("user_id_master"),
                            companyId: formData?.companyId
                        },
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                            
                            getAssignList();
                            setEditableRow(null);  
                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (moduleName) => {
        setExpandedRows((prev) => ({
            ...prev,
            [moduleName]: !prev[moduleName],
        }));
    };

const renderRows = (modules, parentName = null, level = 0) => {
    return modules.map((module) => (
        <React.Fragment key={module.name}>
            <tr>
                <td style={{ paddingLeft: `${level * 30}px` }}>
                    <div className=' ps-2 d-flex align-items-center'>
                    
                        <button
                        // disabled={!module.sub_module}
                        // ${!module.sub_module? "light":"primary" }
                            className={`btn btn-xs py-0 px-0 ${!module.sub_module? "ms-2 me-2 cursorDefault":"me-1"} `}
                            onClick={() => {if(module.sub_module) console.log("clicked"); toggleRow(module.name);}}
                        >
                            <i className={` text-${!module.sub_module? "dark":"primary" } ${!module.sub_module? "ri-checkbox-blank-circle-fill cursorDefault fs-10" : expandedRows[module.name] ? "ri-arrow-down-s-fill cursorPointer fs-24" : "ri-arrow-right-s-fill cursorPointer fs-24"} label-icon align-middle`} />
                        </button>
                        {module.name}
                    </div>
                </td>
                <td>{parentName || '--'}</td>
                <td>
                    <ToggleSwitch
                        isActive={module?.header_status == '1'}
                        isExtFunc={true}
                        onToggle={() =>
                            handleToggleSwitch(module.header_id, module.header_status == "1" ? false : true)
                        }
                    />
                </td>
                   {/* permissions */}
                  <td  >
                    <div className='ps-2 d-flex justify-content-around'>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">View</p>
                           {/* <input
                                type="checkbox"
                                checked={JSON.parse(module?.header_permissions).includes(1)}
                                onChange={() =>
                                    handleCheckboxChange(1, module)
                                }
                                disabled={editableRow !== module.name}
                            /> */}
                            <Switch
                                checked={JSON.parse(module?.header_permissions).includes(1)}
                                onChange={() => handleCheckboxChange(1, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                   
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Add</p>
                             <Switch
                                checked={JSON.parse(module?.header_permissions).includes(2)}
                                onChange={() => handleCheckboxChange(2, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Edit</p>
                            
                             <Switch
                                checked={JSON.parse(module?.header_permissions).includes(3)}
                                onChange={() => handleCheckboxChange(3, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Delete</p>
                           <Switch
                                checked={JSON.parse(module?.header_permissions).includes(4)}
                                onChange={() => handleCheckboxChange(4, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Logs</p>
                           <Switch
                                checked={JSON.parse(module?.header_permissions).includes(5)}
                                onChange={() => handleCheckboxChange(5, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Excel</p>
                           <Switch
                                checked={JSON.parse(module?.header_permissions).includes(6)}
                                onChange={() => handleCheckboxChange(6, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                    </div>
                </td>  
                {/* Action Buttons */}
                <td>
                    <div className='d-flex gap-2'>
                        {editableRow === module.name ? (
                            <button className="btn-icon btn btn-sm btn-success" onClick={() => handlePermission()}>
                                <i className='ri-save-line'/> 
                            </button>
                        ) : (
                            <button className="btn-icon btn btn-sm btn-info" onClick={() => handleEdit(module.name)}>
                                <i className='ri-edit-line' /> 
                            </button>
                        )}
                        {editableRow === module.name && <button className="btn-icon btn btn-sm btn-danger" onClick={handleCancel}>
                            <i className='ri-close-circle-line'/>  
                        </button>
                        }
                    </div>
                   
                </td>
            </tr>
            {expandedRows[module.name] &&
                module.sub_module &&
                renderRows(module.sub_module, module.name, level + 1)}
        </React.Fragment>
    ));
};
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Employee Module Assign`} primary={`Home`} />
                    <div className="row card">
                         
                        <div  className=' card-body'>
                            <div className=' card-header' >
                                <div className='row'>
                                    <div className=' col-md-6 position-relative mb-5'>
                                        {/* <div className=" mx-3 mt-2 mb-1 "> */}
                                            <label>Select Company</label>
                                            <div className=' position-absolute z-2 w-100 pe-3' >
                                                <Select
                                                    onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value }) }}
                                                    placeholder={`Select Company`}
                                                    options={companyOptions}
                                                    value={formData?.companyId ? companyOptions.find(option => option.value == formData?.companyId) : null}
                                                />
                                            </div>
                                            {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                                        {/* </div> */}
                                    </div>
                                    <div className=' col-md-3'>
                                        <div>
                                            <label className="form-label">Assign Module</label>
                                        </div>
                                        <SubmitButton disabled={!formData?.companyId} buttonName='Assign' type='primary' icon='ri-save-line' onClick={()=>{ setAssignModuleModal(true); }} />
                                    </div>
                                </div>
                                
                            </div>
                            <div className=" mt-3">
                                <div style={{ "overflowX": "auto" }}>
                                   
                                    <table style={{ width: "auto", minWidth: "130%"}} className="position-relative table table-bordered table-stripped">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width:"30%"}}>Module Name</th>
                                                <th>Parent Name</th>
                                                <th>Status</th>
                                                <th className='text-center'>Permissions</th> 
                                                <th>Action</th> 
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadingList ? ( 
                                                <LoadingCompnent/>
                                            ) : moduleData.length === 0 ? (
                                                
                                                <tr>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                                </tr>
                                            ) : (
                                                
                                                renderRows(moduleData)
                                            )}
                                            </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {assignModuleModal && (
                            <div className="modal show" 
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }} >
                                <div className="modal-dialog modal-xl">
                                    <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalgridLabel">{"Assign Modules"}</h5>
                                        <button type="button"
                                        disabled={loadingPost} className="btn-close" 
                                        onClick={()=>{
                                            setAssignModuleModal(false);
                                        }} aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                        <div className="card-body">
                                        <form onSubmit={handleSubmit} className="row">
                                            
                                                <div className="col-md-12">
                                                    <label>Modules</label>
                                                    <Select
                                                        onChange={(selectedOptions) => handleSlabMultiSelect("headerList", selectedOptions)}
                                                        placeholder={parentHeaderRows?.length>0?"Select Modules":"None"}
                                                        isMulti
                                                        className={`${errors.headerList ? "is-invalid" : ""}`}
                                                        options={parentHeaderRows}
                                                        value={formData.headerList ? formData.headerList.split(',').map(id => parentHeaderRows.find(option => option.value == id)) : null}
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                borderColor: errors?.headerList ? "red" : base.borderColor,
                                                                boxShadow: errors?.headerList ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                                "&:hover": {
                                                                    borderColor: errors?.headerList ? "red" : base.borderColor,
                                                                },
                                                            }),
                                                        }}
                                                    />
                                                    {errors.headerList && <div className="text-danger">{errors.headerList}</div>}
                                                </div>
                                                <div className="col-md-3 mt-3">
                                                    {/* <button
                                                        disabled={!formData?.companyId || loadingPost}
                                                        type="submit"
                                                        className={`btn btn-primary btn-label waves-effect right waves-light float-right mt-3`}
                                                    >
                                                        <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                        {!loadingPost ? "Assign Module" : "Loading..."}
                                                    </button> */}
                                                    <SubmitButton disabled={!formData?.companyId || loadingPost} buttonName='Assign'  type='primary' icon='ri-save-line' />
                                                </div>
                                        </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>

        </div>
    );
}

export default EmployeeAssignModule;
